import {User} from '@hconnect/apiclient'
import {Checkbox, FormControlLabel, Typography} from '@material-ui/core'
import {Controller, FieldValues} from 'react-hook-form'
import {useLocation} from 'react-router'

import {useTranslation} from '../../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../../Skeleton/UserInformationInputSkeleton'
import {UserInformationProps} from '../types'

type TestUserInputProps<T extends FieldValues> = UserInformationProps<T> & {
  isTester?: boolean
  loggedInUserProfile?: User | null
}

export const TestUserInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isTester,
  isLoading,
  name,
  loggedInUserProfile
}: TestUserInputProps<T>) => {
  const {pathname} = useLocation()
  const isInternal = loggedInUserProfile?.isInternal
  const {t} = useTranslation()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <>
      {readonlyMode && isInternal && isTester && !pathname.includes('managePilot') && (
        <Typography data-test-id="test-user-flag" variant="body2" color="textPrimary" gutterBottom>
          {t('userInformationForm.thisIsATestUser')}
        </Typography>
      )}
      {!readonlyMode && isInternal && !pathname.includes('managePilot') && (
        <Controller
          name={name}
          control={formMethods.control}
          render={({field}) => (
            <FormControlLabel
              {...field}
              checked={field.value}
              data-test-id="label-test-user"
              control={<Checkbox value="isTester" />}
              label={t('userInformationForm.thisIsATestUser')}
            />
          )}
        />
      )}
    </>
  )
}
